import { gql } from '@apollo/client';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

export type CurrentUserDjQuery = {
  currentUser: {
    id: string;
    hasRequestedDj: boolean;
  };
};

export type CurrentUserDjQueryVariables = {
  eventId: string;
};

export const CURRENT_USER_DJ = gql`
  query CurrentUserDj($eventId: ID!) {
    currentUser {
      id
      hasRequestedDj(eventId: $eventId)
    }
  }
` as DocumentNode<CurrentUserDjQuery, CurrentUserDjQueryVariables>;
